import React from 'react';

import { PARTNER_STORE } from '../../domain/repo/store/PartnerStore';
import styles from '../styles/PartnersFormAck.module.scss';

interface PartnersFormAckCmpProps {
  readonly message: string;
  readonly name: string;
  readonly resetFunc: () => void;
}

function PartnersFormAckCmp({
  message,
  name,
  resetFunc,
}: PartnersFormAckCmpProps): React.ReactElement {
  return (
    <div
      className={`${styles['modal-container-ack']} ${styles['flex-col-align-center']}`}
    >
      <div className={`${styles['ack']} ${styles['msg']}`}>
        {PARTNER_STORE.ack_msg}
      </div>
      <div className={`${styles['ack']} ${styles['name']}`}>{name}</div>
      <div className={`${styles['ack']} ${styles['desc']}`}>
        {PARTNER_STORE.ack_desc}
      </div>
      <button
        type="button"
        className={`${styles['bold-txt-btn']} ${styles['request-button']}`}
        onClick={() => resetFunc()}
      >
        {PARTNER_STORE.req_msg}
      </button>
    </div>
  );
}

export default PartnersFormAckCmp;
